<template>
  <div class="overview">
    <NavBer></NavBer>
    <div class="bg1">
        <img src="../assets/images/index/index06.jpg" alt="">
    </div>
    <div class="w content">
      <el-row>
        <el-col :span="24"
          ><div class="grid-content ">
               <div class="profile">
                 <h2>公司简介</h2>
                 <h3>Company profile</h3>
                 <div class="" style="padding: 50px; font-size: 12px;">
							<div style="text-align: left;">
								&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								河北杏林医药物流有限公司是河北省一家具有药品现代物流资质的医药企业，公司位于河北省石家庄市高新区太行西街113号，公司依托先进的智能化仓储系统和高效的配送网络，为医药生产、流通及终端客户提供安全、合规、精准的医药物流服务。</div
							>
							<div style="text-align: left;">
								&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								公司成立于2024年10月22日，获得河北省药品监督管理局批准的药品现代物流企业资质，符合《河北省药品现代物流指导意见》标准。公司经营范围涵盖药品、医疗器械、中药饮片代煎服务、保健食品、预包装食品、消毒剂、日用品、信息咨询、健康咨询、等等。</div
							>
							<div style="text-align: left;">
								&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								公司以“质量第一；用户至上；创造价值；贡献社会”为经营总方针；以“诚信守法经营；严格规范管理；坚持质量第一；竭诚服务客户”为质量方针，依托先进的第三方医药物流配送平台，发展B2B业务（对接医疗机构、药店），可自建电商平台或与互联网医疗平台合作，构建“医+药+物流”闭环生态。未来，公司将持续优化服务，助力医药行业高质量发展，为守护人民健康贡献力量。</div
							>
						</div>
                 <!-- <span>白塔寺药店始创于1872年</span> -->
               </div>
            </div
        ></el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="24"
          ><div class="grid-content ">
               <div class="culture">
                 <h2>企业文化</h2>
                 <h3>Corporate culture</h3>
                 <div class="contenttext">企业精神：诚信  敬业  团结  创新</div>
                 <div class="contenttext">经营方针：顾客至上，质量第一</div>
                 <div class="contenttext">企业作风：勤奋忠诚，严谨高效，热情自信</div>
                 <div class="contenttext">企业使命：为客户创造价值 为大众健康护航</div>
                 <div class="contenttext">企业愿景：让天宇医药成为家喻户晓的健康品牌</div>
               </div>
            </div
        ></el-col>
      </el-row> -->
      
    </div>
    <Footbar></Footbar>
  </div>
</template>

<script>
import NavBer from "../components/nav";
import Footbar from "../components/footbar";
export default {
  components: {
    NavBer,
    Footbar,
  },
};
</script>

<style scoped>
.overview {
  padding-top: 90px;
}
.bg1 {
  width: 100%;
  height: 500px;
  margin-bottom: 10px;
}
.bg1 img {
  width: 100%;
  height: 100%;
}
.content {
  margin-top: 60px;
}
.profile,
.culture{
  width: 100%;
  /* height: 300px; */
 text-align: center;
 background: -webkit-linear-gradient(top left,#F0FF00,#58CFFB);
 padding-top: 50px;
 padding-bottom: 100px;
 
}
.profile h2 {
  color: #333;
}
.profile h3 {
  color: #130CB7;
}
.profile p{
  
  width: 400px;
  margin: 30px auto 10px;
}

.culture {
 background: -webkit-linear-gradient(top left,#43CBFF,#9708CC);
}
.culture h2 {
  color: #333;
}
.culture h3 {
  color: #130CB7;
}
.culture p{
  
  width: 400px;
  margin: 30px auto 10px;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.grid-content {
  border-radius: 4px;
  min-height: 300px;
 
}
.contenttext{
  width: 500px;
  margin: 30px auto 10px;
  color: #fff;
  text-align: left;
  padding-left: 200px;
  
  }
</style>
